import React, { useState, useMemo, useEffect, useContext } from 'react';
import { Row, Col, Button, Typography, Modal } from 'antd';
import { CooksHeader } from '../layout/PageHeader';
import { useLocation, useHistory } from 'react-router-dom';
import { History } from 'history';
import { GoLocation, GoClock } from 'react-icons/go';
import { FaUtensils } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { OldOrderButton } from '../layout/GlobalButton';
import { PlaceOrderHandler } from '../orders/PlaceOrder';
import RestauranTable from '../../assets/images/png/restaurant-table.png';
import Hand from '../../assets/images/png/hand.png';
import {
  CenterProps,
  calcCrow,
} from '../dashboard/components/DesktopMealCarousel';
import { usePosition } from 'use-position';
import { useSelector } from 'react-redux';
import { getUserState } from '../../store/user/selector';
import { AccountTypeContext } from '../dashboard/Dashboard';
import { AuthModalContent } from '../layout/Header';
// import { Navbar } from '../layout/Header';

export interface MealDetailsProps {
  meal?: any;
  // onClick?: (e?: React.MouseEvent) => void;
}

export const MealDetailsCoverImage: React.FC<MealDetailsProps> = ({ meal }) => {
  const { cookDetails } = meal;
  const [cooksLocation, setCooksLocation] = useState<CenterProps>();
  const { user } = useSelector(getUserState);
  const { forWho } = useContext(AccountTypeContext);
  const history: History = useHistory();
  const settings = useMemo(
    () => ({ enableHighAccuracy: true, timeout: 0, maximumAge: Infinity }),
    []
  );

  const watch = true;
  const { latitude, longitude } = usePosition(watch, settings);

  const cookLocation = () => {
    if (cookDetails) {
      setCooksLocation({ ...cookDetails?.location });
    }
  };

  const handleCancelPress = () => {
    Modal.destroyAll();
  };

  const handleLinkClick = (link: string) => (): void => {
    history.push(link);
    setTimeout(() => {
      Modal.destroyAll();
    }, 500);
  };

  const restrictionModalConfig = {
    icon: null,
    false: true,
    maskClosable: true,
    className: 'modal-content-container modal-content-description',
    okButtonProps: { style: { display: 'none' } },
    content: (
      <AuthModalContent
        onCreateAccountPress={handleLinkClick(
          `/authentication/registration/${forWho}`
        )}
        onLoginAccountPress={handleLinkClick(
          `/authentication/login/email/${forWho}`
        )}
        onPressCancel={handleCancelPress}
      />
    ),
  };

  const handleOnClickItem = () => {
    if (user.userid) {
      PlaceOrderHandler({ meal, history });
      return;
    }
    Modal.info(restrictionModalConfig);
  };
  const { t } = useTranslation();
  useEffect(cookLocation, [cookDetails]);
  return (
    <div className="meal-cover-image">
      <div
        style={{
          backgroundImage: `url(${meal.image})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
        className="image-cover"
      />
      <Row className="meal-icon-container">
        <Row className="icon-container">
          <GoLocation color="#B0B1B2" size={15} />
          <Typography.Text className="kilometer-text">
            {calcCrow(
              cooksLocation?.lat,
              cooksLocation?.lng,
              latitude,
              longitude
            ).toFixed(2)}{' '}
            km
          </Typography.Text>
        </Row>
        <Row className="icon-container">
          <GoClock color="#B0B1B2" size={15} />
          <Typography.Text className="time-text">{meal.time}</Typography.Text>
        </Row>
        <div className="price-container">
          <Typography.Text className="price-text">
            {`Kč ${meal.price}.00`}
          </Typography.Text>
        </div>
      </Row>
      <Col className="old-meal-details-content">
        <FaUtensils color="#9c9c9c" size={12} />
        <span className="text">
          {meal.portions} {t('Quantity')} {t('Available')}
        </span>
        <Col span={24} className="meal-details-container">
          <Typography.Text className="meal-title">{meal.title}</Typography.Text>
          <Typography.Text className="meal-details-description">
            {meal.description}
          </Typography.Text>
        </Col>
      </Col>
      <Row className="old-meal-details-content">
        <Button
          type="default"
          icon={<img src={RestauranTable} alt="table-icon" />}
          className="table-icon"
          size="small"
        >
          <span className="text">{t('Eat with')} max 30 mins</span>
        </Button>
        <Button
          type="default"
          icon={<img src={Hand} alt="restaurant-icon" />}
          className="table-icon"
          size="small"
        >
          <span className="text">{t('Take away')}</span>
        </Button>
      </Row>
      <div className="old-orderbutton-container">
        <OldOrderButton onclick={handleOnClickItem} />
      </div>
    </div>
  );
};

export const MealDetails: React.FC = () => {
  const location = useLocation();
  const { state } = location;
  return (
    <div className="profile">
      <CooksHeader headerTitle="Meal Details" />
      {/* <Row justify="start" className="header-container">
        <Navbar />
      </Row> */}
      <Row justify="center" className="cooks-container">
        <Col
          xs={24}
          sm={24}
          md={14}
          lg={10}
          xl={10}
          className="old-tab-header-container"
        >
          <MealDetailsCoverImage meal={state} />
        </Col>
      </Row>
    </div>
  );
};
